import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'radius-top-right', 'IconRadiusTopRight', [["path",{"d":"M5 5h6a8 8 0 0 1 8 8v6","key":"svg-0"}]]);